import { AuthService } from './auth.service';

export function checkIfUserIsAuthenticated(authService: AuthService) {
    return () => {        
        return authService.verificarSession();
    };
}